var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwardwinning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4287_39925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3851 9.46094H14.7697C13.8835 9.46094 13.1543 10.1902 13.1543 11.0763V19.384C13.1543 20.2702 13.8835 20.9994 14.7697 20.9994H19.3851C20.2712 20.9994 21.0005 20.2702 21.0005 19.384V11.0763C21.0005 10.1902 20.2712 9.46094 19.3851 9.46094ZM17.5389 18.2302H16.6158C16.2374 18.2302 15.9235 17.9163 15.9235 17.5379C15.9235 17.1594 16.2374 16.8456 16.6158 16.8456H17.5389C17.9174 16.8456 18.2312 17.1594 18.2312 17.5379C18.2312 17.9163 17.9174 18.2302 17.5389 18.2302Z",
    fill: "#299310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80833 17.7688H7.38371C7.00525 17.7688 6.69141 18.0826 6.69141 18.4611C6.69141 18.8395 7.00525 19.1534 7.38371 19.1534H11.7683V16.8457H8.11294L7.80833 17.7688Z",
    fill: "#299310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3846 8.07692C19.6246 8.07692 19.8554 8.11385 20.0769 8.16923V5.53846C20.0769 4.13538 18.9415 3 17.5385 3H5.53846C4.13538 3 3 4.13538 3 5.53846V11.3077H11.7692V11.0769C11.7692 9.42462 13.1169 8.07692 14.7692 8.07692H19.3846Z",
    fill: "#299310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12.9222C3 14.3253 4.13538 15.4606 5.53846 15.4606H11.7692V12.6914H3V12.9222Z",
    fill: "#299310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49354 5.77216C8.49354 4.60391 7.54198 3.65234 6.37372 3.65234C5.20547 3.65234 4.25391 4.60391 4.25391 5.77216C4.25391 6.94042 5.20547 7.89198 6.37372 7.89198C7.54198 7.89198 8.49354 6.94042 8.49354 5.77216ZM6.37372 6.94984C5.72365 6.94984 5.19605 6.42224 5.19605 5.77216C5.19605 5.12208 5.72365 4.59449 6.37372 4.59449C7.0238 4.59449 7.5514 5.12208 7.5514 5.77216C7.5514 6.42224 7.0238 6.94984 6.37372 6.94984Z",
    fill: "#299310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.37359 7.11633C7.11603 7.11633 7.71789 6.51447 7.71789 5.77203C7.71789 5.0296 7.11603 4.42773 6.37359 4.42773C5.63116 4.42773 5.0293 5.0296 5.0293 5.77203C5.0293 6.51447 5.63116 7.11633 6.37359 7.11633Z",
    fill: "#299310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3887 8.33216L8.53764 7.19531C8.21417 7.68523 7.73053 8.05894 7.16211 8.24109L8.0069 9.36852C8.05086 9.42819 8.12309 9.46273 8.19532 9.46273C8.21417 9.46273 8.23301 9.46273 8.25499 9.45645C8.34607 9.43133 8.41516 9.35596 8.43086 9.26174L8.52193 8.61481L9.16887 8.70588C9.25994 8.71844 9.3573 8.67447 9.40441 8.59282C9.45151 8.51117 9.44837 8.40753 9.3887 8.33216Z",
    fill: "#299310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21072 7.19531L3.35965 8.33216C3.30312 8.40753 3.29684 8.51117 3.34395 8.59282C3.39106 8.67447 3.48527 8.71844 3.57948 8.70588L4.22642 8.61481L4.31749 9.26174C4.33006 9.35596 4.39915 9.43133 4.49336 9.45645C4.5122 9.46273 4.53105 9.46273 4.55303 9.46273C4.62526 9.46273 4.69749 9.42819 4.74146 9.36852L5.58625 8.24109C5.01782 8.05894 4.53419 7.68523 4.21072 7.19531Z",
    fill: "#299310"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4287_39925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardwinning);
export default __webpack_public_path__ + "static/media/award winning.8ffccced.svg";
export { ForwardRef as ReactComponent };